export const getErrorMessage = (
  error,
  defaultError = "Something went wrong. Please try again."
) => {
  if (!error) return "";
  const err = error;
  if (err?.response?.data?.message) return err.response.data.message;
  if (err?.error?.data?.message) return err.error.data.message;
  if (err?.data?.message) return err.data.message;
  if (typeof err?.data === "string") return err.data;
  if (err?.error) return err.error;
  if (typeof err === "string") return err;

  return defaultError;
};
